import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';



const Footer: React.FC = () => {
  return (
    <Box
      component='footer'
      sx={{
        bgcolor: '#000000',
        color: '#ffffff',
        py: { xs: 2, sm: 2.5 },
      }}
    >
      <Container maxWidth='lg'>
        {/* <Divider sx={{ borderColor: 'rgba(255,255,255,0.35)', mb: { xs: 4, md: 5 } }} /> */}

        <Stack gap={2} sx={{display: 'flex', flexDirection: {xs: 'column', sm: 'row'}, justifyContent: 'center', alignItems:{xs: 'center', sm: 'flex-end'}}}>
          <Box sx={{ display: 'flex',  justifyContent: 'center' }}>
            <Box
              component='img'
              src='/static/images/qr_buddy_log_white.png'
              alt='Sterling Cadillac logo'
              sx={{
                width: 150,
                maxWidth: '100%',
                height: 'auto',
                objectFit: 'contain',
                filter: 'grayscale(1) brightness(1.15)',
              }}
            />
          </Box>
        
          <Typography mb={.5}>{`© ${new Date().getFullYear()} KnoCard LLC. All rights reserved.`}</Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
